import { toast } from '../ui/toast';

/** Registers the service worker in production builds and surfaces updates to the user. */
export async function registerPWA() {
  if (!import.meta.env.PROD || !('serviceWorker' in navigator)) return;
  const { registerSW } = await import('virtual:pwa-register');
  const update = registerSW({
    onNeedRefresh() {
      toast('A new version is available', {
        sticky: true,
        action: { label: 'RELOAD', run: () => void update(true) },
      });
    },
    onOfflineReady() {
      toast('Ready to work offline', { color: 'var(--sage)' });
    },
  });
}
